import React from 'react';

interface Props {
    className: string;
}
export default class SidebarHeaderCallout extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { children, className } = this.props;

        let classNames: Array<string> = ['ct-sidebar__header-callout'];
        if (className) {
            classNames.push(className);
        }

        return <div className={classNames.join(' ')}>{children}</div>;
    }
}
